module.exports = __webpack_public_path__ + "static/media/Akemi_3042.cfbb66ee.jpg";